<template>
  <el-tooltip
    effect="dark"
    :content="contentHover"
    placement="top"
    :disabled="isShowTooltip"
  >
    <div
      class="overview_container"
      :style="{ padding: `0 ${paddingLR}px` }"
      @mouseover="onMouseOver()"
    >
      <div>
        <span ref="name">{{ content }}</span>
      </div>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    paddingLR: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      isShowTooltip: false,
      contentHover: ''
    };
  },
  methods: {
    onMouseOver() {
      // 内容超出，显示文字提示内容
      const tag = this.$refs.name;
      const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth;
      // 鼠标悬停后显示的内容
      this.contentHover = this.content;
    }
  }
};
</script>

<style lang="scss" scoped>
.overview_container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  text-align: center;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
